import AllApplicationsTemplate from "./Template";

const AllLeaveApplications = () => <AllApplicationsTemplate type="leave" />;

export default AllLeaveApplications;
